import OneUp from '../assets/club-logos/1UP.webp';
import Act4Impact from '../assets/club-logos/Act4Impact.webp';
import AnimeClub from '../assets/club-logos/AnimeClub.webp';
import BehindTheScenes from '../assets/club-logos/BehindTheScenes.webp';
import BestBuddies from '../assets/club-logos/BestBuddies.webp';
import Chess from '../assets/club-logos/Chess.webp';
import ComputerStudies from '../assets/club-logos/csclub.webp';
import CSA from '../assets/club-logos/CSA.webp';
import Dance from '../assets/club-logos/Dance.webp';
import Debate from '../assets/club-logos/Debate.webp';
import Drama from '../assets/club-logos/Drama.webp';
import EASA from '../assets/club-logos/EASA.webp';
import Equity from '../assets/club-logos/equity.webp';
import Fashion from '../assets/club-logos/Fashion.webp';
import FencingClub from '../assets/club-logos/fencingClub.webp';
import Geography from '../assets/club-logos/Geography.webp';
import GreenInc from '../assets/club-logos/greeninc.webp';
import HealthySchools from '../assets/club-logos/Healthy Schools.webp';
import History from '../assets/club-logos/History.webp';
import HOSA from '../assets/club-logos/HOSA.webp';
import Ignite from '../assets/club-logos/Ignite.webp';
import InvisibleString from '../assets/club-logos/InvisibleString.webp';
import MathSoc from '../assets/club-logos/MathSoc.webp';
import MillikenMoments from '../assets/club-logos/Milliken Moments.webp';
import ModelUN from '../assets/club-logos/ModelUN.webp';
import MBO from '../assets/club-logos/MBO.webp';
import ReachForTheTop from '../assets/club-logos/reach for the top.webp';
import RedCross from '../assets/club-logos/Red cross.webp';
import Robotics from '../assets/club-logos/robotics.webp';
import STEMPower from '../assets/club-logos/STEMPower.webp';
import VEX from '../assets/club-logos/VEX.webp';
import YOSA from '../assets/club-logos/YOSA.webp';
import YSS from '../assets/club-logos/YSS.webp';
import TSA from '../assets/club-logos/TSA.webp';
import MSA from '../assets/club-logos/MSA.webp';
import French from '../assets/club-logos/French.webp'
import Weightroom from '../assets/club-logos/Weightroom.webp'
import DND from '../assets/club-logos/DND.webp'
import Kitchen from '../assets/club-logos/DND.webp'
import MAC from '../assets/club-logos/DND.webp'
import Music from '../assets/club-logos/Music.webp'
import Newcomers from '../assets/club-logos/Newcomers.webp'
import Yearbook from '../assets/club-logos/Yearbook.webp'
import PFA from '../assets/club-logos/PFA.webp'
import Typewriter from '../assets/club-logos/Typewriter.webp'

export const clubResources = [ 
    { 
        name: "Club Contact Form",
        description: "Fill out the Club Contact Form to help us keep track of all clubs at Milliken!",
        link:"https://forms.gle/UbBZGUUqMQmVQan56"
    },
    /*{ 
        name: "Club Grants",
        description: "Need funding for your club's activities? Apply through the Club Grants form to receive financial support!",
        link:"https://docs.google.com/forms/d/e/1FAIpQLSepbSQALTazi4agbmk-fP2EaO6cwz8kxb0U4B5K5vDEJp1nxQ/viewform?usp=sf_link"
    },
    { 
        name: "Grant Success Criteria",
        description: "Wondering what makes a strong grant application? Review the Grant Success Criteria to ensure your application meets all the necessary requirements.",
        link:"https://docs.google.com/document/d/1JZ2KVYu4j0xglI_4MJyvIL0HfS58rinpue751IxDi4c/edit?usp=sharing"
    }, */
    { 
        name: "Club Proposal Form",
        description: "Planning a new club? Submit your proposal through the Club Proposal Form for approval.",
        link:"https://forms.gle/7Bfi59AZmRMaMGtx5"
    },
    { 
        name: "Event Proposal Form",
        description: "Planning a new event? Submit your proposal through the Event Proposal Form for approval.",
        link:"https://forms.gle/q1uMf6LmEWNegtHf6"
    },
    { 
        name: "Calendar Submission Form",
        description: "Want your event to be added to the club calendar so other students and execs know what is going on when?",
        link:"https://forms.gle/2bwf4hCPAE5tPXzU6"
    }
]

const clubData = [
    {
        name: "1UP",
        desc: "Milliken’s forefront urban planning and architecture club - investigating and solving community issues through design-thinking.",
        imgSrc: OneUp,
        link: "https://www.instagram.com/1upmilliken/",
        room: "221",
        meetingDay: "Thursday",
        googleClassroomCode: "vsjr3cz"
    },
    {
        name: "Act 4 Impact",
        desc: "Act 4 Impact is a volunteering club looking to fundraise and make a local impact on our 4 pillars: Poverty, Hunger, Education, and the Environment.",
        imgSrc: Act4Impact,
        link: "https://www.instagram.com/act4impactorg/",
        room: "315",
        meetingDay: "Wednesday",
        googleClassroomCode: "hafbw2n"
    },
    {
        name: "Anime Club",
        desc: "We watch anime, eat snacks, and chill.",
        imgSrc: AnimeClub,
        link: "https://www.instagram.com/mmhs.animeclub/",
        room: "107",
        meetingDay: "Friday",
        googleClassroomCode: "N/A"
    },
    {
        name: "Best Buddies",
        desc: "This club promotes inclusion in the school community by creating meaningful relationships between those with and without intellectual and developmental disabilities.",
        imgSrc: BestBuddies,
        link: "https://www.instagram.com/mmhs_bestbuddies/",
        room: "234B",
        meetingDay: "Wednesday",
        googleClassroomCode: "3nn2k3m"
    },
    {
        name: "Chinese Students Association",
        desc: "Our club is for anyone who wants to learn about Chinese culture.",
        imgSrc: CSA,
        link: "https://www.instagram.com/mmhs_csa/",
        room: "ESL CLASSROOMS",
        meetingDay: "Wednesday",
        googleClassroomCode: "wfejf6k"
    },
    {
        name: "Computer Studies Club",
        desc: "We love to teach programming at all levels.",
        imgSrc: ComputerStudies,
        link: "https://www.instagram.com/milliken_compsci/",
        room: "306",
        meetingDay: "Tuesday, Wednesday",
        googleClassroomCode: "3mc5ybeg"
    },
    {
        name: "Debate Club",
        desc: "We debate!",
        imgSrc: Debate,
        link: "https://www.instagram.com/milliken.debate/",
        room: "321",
        meetingDay: "Friday",
        googleClassroomCode: "N/A"
    },
    {
        name: "Drama Club",
        desc: "We host performances for the school/community.",
        imgSrc: Drama,
        link: "https://www.instagram.com/millikendrama/",
        room: "Drama Room (Rm. 134)",
        meetingDay: "Friday",
        googleClassroomCode: "iqxheck"
    },
    {
        name: "EASA (East Asian Student Association)",
        desc: "EASA is a club that unites the East Asian community at MMHS by uplifting diverse voices and showcasing cultural traditions through engaging events.",
        imgSrc: EASA,
        link: "https://www.instagram.com/milliken_easa/",
        room: "226",
        meetingDay: "Wednesday",
        googleClassroomCode: "3y4xu4e"
    },
    {
        name: "Equity Club",
        desc: "We work towards building a more equitable community at Milliken and beyond!",
        imgSrc: Equity,
        link: "https://www.instagram.com/milliken_equity/",
        room: "315",
        meetingDay: "Thursday",
        googleClassroomCode: "imuvpn6"
    },
    {
        name: "Fencing Club",
        desc: "Fencing Club is a place for everyone to enjoy the fascinating sport of fencing.",
        imgSrc: FencingClub,
        link: "https://www.instagram.com/mmhsfencingclub/",
        room: "Small Gym",
        meetingDay: "Wednesday",
        googleClassroomCode: "qfiojr5"
    },
    {
        name: "Green Inc",
        desc: "We strive for an environment that fosters a clean and sustainable environment.",
        imgSrc: GreenInc,
        link: "https://www.instagram.com/mmhs_green_inc/",
        room: "330",
        meetingDay: "Friday",
        googleClassroomCode: "edwesj2"
    },
    {
        name: "Healthy Schools Club",
        desc: "The goal of the Healthy School Student Club is to provide student engagement and fun opportunities, fostering mental and physical health development.",
        imgSrc: HealthySchools,
        link: "https://www.instagram.com/mmhshealthyschools/",
        room: "Portables/128",
        meetingDay: "Thursday",
        googleClassroomCode: "cidmbxh"
    },
    {
        name: "History Club",
        desc: "A club dedicated to exploring all aspects of history.",
        imgSrc: History,
        link: "https://www.instagram.com/mmhshistoryclub/",
        room: "215",
        meetingDay: "Thursday",
        googleClassroomCode: "kxba6oh"
    },
    {
        name: "HOSA",
        desc: "Milliken's HOSA Chapter empowers future health leaders through education, skill development, and competition in health-related fields.",
        imgSrc: HOSA,
        link: "https://www.instagram.com/millikenhosa/",
        room: "323 and 324",
        meetingDay: "Monday",
        googleClassroomCode: "d2vi5vs"
    },
    {
        name: "Ignite Christian Fellowship",
        desc: "Ignite is a place for Christians to grow in their faith and for non-Christians to meet new and welcoming people.",
        imgSrc: Ignite,
        link: "https://www.instagram.com/mmhs_ignitecf/",
        room: "245",
        meetingDay: "Monday",
        googleClassroomCode: "jtq6baef"
    },
    {
        name: "Invisible String",
        desc: "We create a fun place for everyone to let their creativity flow!",
        imgSrc: InvisibleString,
        link: "https://www.instagram.com/mmhs_invisiblestring/",
        room: "106",
        meetingDay: "Monday",
        googleClassroomCode: "7j75ly3"
    },
    {
        name: "MathSoc",
        desc: "A club at Milliken dedicated to all things math.",
        imgSrc: MathSoc,
        link: "https://www.instagram.com/mmhs.mathsoc/",
        room: "314",
        meetingDay: "Monday",
        googleClassroomCode: "vihkpuu6"
    },
    {
        name: "MBO (Milliken Business Organization)",
        desc: "Milliken Business Organization is the place to learn and participate in business-related opportunities and competitions!",
        imgSrc: MBO,
        link: "https://www.instagram.com/mmhs.mbo/",
        room: "Business Rooms",
        meetingDay: "Thursday",
        googleClassroomCode: "btfvct7"
    },
    {
        name: "Milliken Geography Club",
        desc: "A place to promote, learn, and develop geographic skills; A place to understand the world.",
        imgSrc: Geography,
        link: "https://www.instagram.com/milliken.geography.club/",
        room: "222",
        meetingDay: "Thursday",
        googleClassroomCode: "d2by6cu"
    },
    {
        name: "Milliken Moments",
        desc: "Milliken Moments is the official school newspaper that captures and highlights key events.",
        imgSrc: MillikenMoments,
        link: "https://www.instagram.com/milliken.moments/",
        room: "106",
        meetingDay: "Tuesday",
        googleClassroomCode: "ugk7yaa"
    },
    {
        name: "Behind The Scenes",
        desc: "This club specializes in both photography and filmography for MMHS events.",
        imgSrc: BehindTheScenes,
        link: "https://www.instagram.com/mmhs_behindthescenes/",
        room: "161",
        meetingDay: "Monday",
        googleClassroomCode: "sbfvkd7"
    },

    {
        name: "Chess Club",
        desc: "A club where anyone can come to play and learn chess!",
        imgSrc: Chess,
        link: "https://www.instagram.com/mmhschess/",
        room: "106",
        meetingDay: "Wednesday",
        googleClassroomCode: "t3wntjz"
    },
    {
        name: "Dance Club",
        desc: "MMHS Dance Club is founded by students who enjoy the art of dance and are passionate about sharing our skills.",
        imgSrc: Dance,
        link: "https://www.instagram.com/mmhs_danceclub/",
        room: "125",
        meetingDay: "Monday",
        googleClassroomCode: "yjldpz4"
    },
    {
        name: "Fashion",
        desc: "Our club aims to provide a place for students to express themselves and explore their love for fashion with different workshops and activities biweekly!",
        imgSrc: Fashion,
        link: "https://www.instagram.com/millikenfashion/",
        room: "125/226",
        meetingDay: "Thursday",
        googleClassroomCode: "g26dzgc"
    },
    {
        name: "Reach for The Top",
        desc: "We’re a trivia game show club that aims to provide a fun experience to our members.",
        imgSrc: ReachForTheTop,
        link: "https://www.instagram.com/milliken_reach/",
        room: "314/315/318",
        meetingDay: "Jr - Wed / Sr - Thursday",
        googleClassroomCode: "bxa7dd7"
    },
    {
        name: "Red Cross",
        desc: "Milliken Red Cross is a vibrant student organization committed to service, which follows the principles of the Canadian Red Cross.",
        imgSrc: RedCross,
        link: "https://www.instagram.com/redcrossmilliken/",
        room: "327",
        meetingDay: "Friday",
        googleClassroomCode: "3c2ffgo"
    },
    {
        name: "Silver Knights Robotics Team 9569",
        desc: "We build big sexy robots.",
        imgSrc: Robotics,
        link: "https://www.instagram.com/mmhs.robotics/",
        room: "161",
        meetingDay: "Friday",
        googleClassroomCode: "y56ms5q"
    },
    {
        name: "STEMPower",
        desc: "Stempowering minorities at Milliken with the tools to level up in STEM!",
        imgSrc: STEMPower,
        link: "https://www.instagram.com/stempowerus/",
        room: "319",
        meetingDay: "Wednesday",
        googleClassroomCode: "fnryqk7"
    },
    {
        name: "Vex Robotics Club",
        desc: "We build robots that compete in the VEX Robotics Competition.",
        imgSrc: VEX,
        link: "https://www.instagram.com/milliken.vex/",
        room: "161",
        meetingDay: "Wednesday",
        googleClassroomCode: "e5f6t32"
    },
    {
        name: "YOSA (Youth of South Asia)",
        desc: "YOSA (Youth of South Asia) is a school club dedicated to organizing inclusive events that celebrate South Asian culture and promote diversity for everyone to enjoy.",
        imgSrc: YOSA,
        link: "https://www.instagram.com/mmhs_yosa/",
        room: "161",
        meetingDay: "Tuesday",
        googleClassroomCode: "posur77"
    },
    {
        name: "Young Scientists Society (YSS)",
        desc: "Fostering a love of Science among youth for the Future",
        imgSrc: YSS,
        link: "https://www.instagram.com/mmhs_knightrogen/",
        room: "320",
        meetingDay: "Friday",
        googleClassroomCode: "heishcg"
    },
    {
        name: "Tamil Student Association (TSA)",
        desc: "A student led club that aims to promote recognition and diversity of the Tamil culture.",
        imgSrc: TSA,
        link: "https://www.instagram.com/milliken.tsa/",
        room: "303",
        meetingDay: "Friday",
        googleClassroomCode: "s6ajoxg"
    },
    {
        name: "Model United Nations (MUN)",
        desc: "Model un simulates UN discussions, students use roleplays to debate global issues and develop diplomatic skills.",
        imgSrc: ModelUN,
        link: "https://www.instagram.com/millikenmodelun/",
        room: "302",
        meetingDay: "Friday",
        googleClassroomCode: "si22ix2"
    },
    {
        name: "Muslim Student Association (MSA)",
        desc: "The Muslim Student Association is a club where Muslim and non Muslims have a safe space to discuss about their faith and beliefs. There are charity and Eid events organized. ",
        imgSrc: MSA,
        link: "https://www.instagram.com/msa.milliken/",
        room: "242A",
        meetingDay: "Wednesday",
        googleClassroomCode: "x6d6b4m"
    },
    {
        name: "French Club",
        desc: "A space to develop our French skills with activities and games, so we can say more than just 'oui oui baguette' with confidence!",
        imgSrc: French,
        link: "https://www.instagram.com/mmhs.frenchclub/",
        room: "316/226",
        meetingDay: "Wednesday",
        googleClassroomCode: "trlklsj"
    },
    {
        name: "Weight Room",
        desc: "A space for students to get involved it weigh training and cardio that fosters long term health lifsetyle, mental health and overall well being  while being a place of belonging.",
        imgSrc: Weightroom,
        link: "https://www.instagram.com/mmhs.weightroom/",
        room: "Weight Room",
        meetingDay: "Friday",
        googleClassroomCode: "cno2qo6"
    },
    {
        name: "Milliken Athletic Council (MAC)",
        desc: "We oversee all athletics at milliken, also encourging participation and growing involvement in sports from the student body.",
        imgSrc: MAC,
        link: "https://www.instagram.com/mmhsmac/",
        room: "Large Gym",
        meetingDay: "Friday",
        googleClassroomCode: "yfno6fm"
    },
    {
        name: "Yearbook",
        desc: "Milliken yearbook is dedicated to capturing all aspects of this year at Milliken through photography, design and writing- all encapsulated into one Yearbook.",
        imgSrc: Yearbook,
        link: "https://www.instagram.com/yearbook/",
        room: "106, 107",
        meetingDay: "Monday",
        googleClassroomCode: "xdarm3yo, shd7xgy, nbwp7fs"
    },
    {
        name: "Dungeons and Dragons",
        desc: "We play Dungeons and Dragons, a table top roleplaying game and have lots of fun!",
        imgSrc: DND,
        link: "https://www.instagram.com/mmhsdungeonsdragons/",
        room: "107",
        meetingDay: "Tuesday",
        googleClassroomCode: "vkw3qeo"
    },
    {
        name: "Knights Kitchen",
        desc: "Knights Kitchen is a club dedicated to inspiring  creativity through collaborative culinary workshops, inspiring our club members to innovate, share, and grow their passion for cooking and baking. ",
        imgSrc: Kitchen,
        link: "https://www.instagram.com/mmhs_kitchen/",
        room: "107",
        meetingDay: "Thursday",
        googleClassroomCode: "yzt2s2y"
    },
    {
        name: "Newcomers' Club",
        desc: "“The Newcomers’ Club is a welcoming community at MMHS dedicated to helping new students — whether Grade 9, ESL, or recent arrivals — build friendships, adapt to school life, and find the guidance they need to thrive.”",
        imgSrc: Newcomers,
        link: "https://www.instagram.com/mmhs_newcomers/",
        room: "242A",
        meetingDay: "Friday",
        googleClassroomCode: "wsrdfk7s"
    },
    {
        name: "Music Council",
        desc: "Milliken yearbook is dedicated to capturing all aspects of this year at Milliken through photography, design and writing- all encapsulated into one Yearbook.",
        imgSrc: Music,
        link: "https://www.instagram.com/millikenmusic/",
        room: "112",
        meetingDay: "Monday",
        googleClassroomCode: "N/A"
    },
    {
        name: "Paws First Alliance",
        desc: "Paws First Alliance is a club dedicated to raising awareness about ethical issues surrounding animals.",
        imgSrc: PFA,
        link: "https://www.instagram.com/pawsfirstalliance/",
        room: "224",
        meetingDay: "Friday",
        googleClassroomCode: "2hfg7jpe"
    },
    {
        name: "Music Council",
        desc: "Teaching students to express themselves through different forms of writing.",
        imgSrc: Typewriter,
        link: "https://www.instagram.com/millikens.typewriter/",
        room: "Varies",
        meetingDay: "Friday",
        googleClassroomCode: "Woonxdz"
    }
];

export default clubData;
